export default __webpack_public_path__ + "static/media/iconconq.8089c2c6.png";